import { isEmpty, INPUT_TYPE } from "deskera-ui-library";
import PermissionUtils, { ACTION, MODULE } from "../components/user-permissions/PermissionUtils";
import { CONSTANTS } from "../constants/Constant";
import { COUNTRY } from "../constants/CountryConstant";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import Utility from "./Utility";

export default class DataGridUtility {
  static getFormElements(columnsData, defaultValue, exemptOptionsMap) {
    return columnsData.map((column) => {
      return {
        ...column,
        title: column.name,
        value:
          defaultValue && defaultValue[column.id]
            ? defaultValue[column.id]
            : column.value,
        options: isEmpty(column.options)
          ? []
          : exemptOptionsMap
          ? column.options
          : column.options.map((option) => {
              return option.name;
            }),
        readOnly:
          column.columnCode === "emailId"
            ? defaultValue && !isEmpty(defaultValue[column.id])
              ? true
              : false
            : this.checkIsFieldReadOnly(column.columnCode, column.readOnly),
      };
    });
  }

  static getPaymentFormElements(
    columnsData,
    defaultValue,
    exemptOptionsMap,
    isInviteUser
  ) {
    return columnsData.map((column) => {
      return {
        ...column,
        title: column.name,
        value:
          defaultValue && defaultValue[column.id]
            ? defaultValue[column.id]
            : column.value,
        options: isEmpty(column.options)
          ? []
          : exemptOptionsMap
          ? column.options
          : column.options.map((option) => {
              return option.name;
            }),
        readOnly:
          column.columnCode === "emailId"
            ? defaultValue && !isEmpty(defaultValue[column.id])
              ? true
              : false
            : this.checkIsFieldReadOnly(column.columnCode, column.readOnly),
        required: isInviteUser ? false : column.required,
      };
    });
  }

  static checkIsFieldReadOnly(columnCode, isReadOnly) {
    if (!TenantService.get(TENANT.IS_ADMIN) 
    // && !PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT, ACTION.CREATE])
    ) {
      const readOnlyField = [
        "isEffectiveSalary",
        "effectiveDate",
        "employeeType",
        "defaultCompensation",
        "effectivePeriod",
        "ctc",
        "period",
        "selectStateIndicator",
        "fdeWthForEEInSameTerritory",
        "allState",
        "residentCountry",
        "statutoryIndicator",
        "taxesApplicable",
        "laborWelfareFund",
        "pf",
        "professionalTax",
        "taxExemption",
        "esiApplicable",
      ];
      if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US) {
        readOnlyField.push(
          "firstName",
          "lastName",
          "designation",
          "dateOfJoining",
          "foreignEarnedIncome",
          "taxExemptions",
          "inviteUserToFillInfo"
        );
      }
      if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US && !TenantService.get(TENANT.IS_ADMIN)) {
        let editableField = [
          'federalFilingStatus'
        ]
        if(editableField.some((item) => columnCode === item)) {
          return false
        }
      } 
        return readOnlyField.some((item) => columnCode === item)
        ? true
        : isReadOnly;   
    }
    return isReadOnly;
  }

  static getFormElementsByKey(columnsData, defaultValue) {
    return columnsData.map((column) => {
      return {
        ...column,
        title: column.name,
        value:
          defaultValue && defaultValue[column.key]
            ? DataGridUtility.getFieldValue(defaultValue, column)
            : DataGridUtility.getFieldValue(defaultValue, column),
        options: isEmpty(column.options) ? [] : column.options,
      };
    });
  }
  static getFieldValue(defaultValue, column) {
    if (
      column.type == INPUT_TYPE.SELECT ||
      column.type == INPUT_TYPE.MULTI_SELECT
    ) {
      let options = isEmpty(column.options) ? [] : column.options;
      let selectedOption = 0;
      options.forEach((opt, index) => {
        if (opt.value == defaultValue[column.key]) {
          selectedOption = index;
          return index;
        }
      });
      if (
        column.type == INPUT_TYPE.MULTI_SELECT &&
        column.columnCode == "workWeek"
      ) {
        if (defaultValue[column.key]) {
          selectedOption = defaultValue[column.key].map((ele) => {
            return ele == 0 ? 6 : ele - 1;
          });
        } else {
          return [0, 1, 2, 3, 4];
        }
      }
      return selectedOption;
    } else {
      return defaultValue[column.key];
    }
  }

  static getRowData(formData, columns) {
    let rowData = {};
    formData.forEach((obj) => {
      if (obj.value !== undefined && obj.value !== null) {
        if (
          obj.type === INPUT_TYPE.SELECT ||
          obj.type === INPUT_TYPE.MULTI_SELECT ||
          obj.type === 'dropdown'
        ) {
          const currentColumn = columns.find(
            (column) => obj.key === column.key
          );
          const option_values = obj.value.filter(
            (index) => currentColumn.options[index]?.id !== null && currentColumn.options[index]?.id !== undefined && currentColumn.options[index]?.id !== ""
          ).map((i) => {return currentColumn.options[i]?.id});
          rowData[obj.key] = option_values;
        } else {
          if (obj.type === INPUT_TYPE.DATE) {
            rowData[obj.key] = obj.value;
          } else if (!isEmpty(obj.value)) {
            rowData[obj.key] = obj.value;
          }
        }
      }
    });
    return rowData;
  }

  static getFieldData(value, field, options) {
      let rowData = CONSTANTS.EMPTY_STRING;
    if(!Utility.isEmpty(value)) {
        if(field.type === INPUT_TYPE.SELECT && !Utility.isEmpty(value.length)) {
            const valueFromOptions = options[value[0]];
            if(!Utility.isEmpty(valueFromOptions)) {
                rowData = valueFromOptions.id;
            }
        } else if(field.type ===  INPUT_TYPE.DATE) {
            rowData = value;
        } else if(!Utility.isEmpty(value)) {
            rowData = value;
        }
    }
    return rowData;
  }

  static getMultiSelectFieldData(value, field, options) {
    const data = [];
    if(!Utility.isEmpty(value)) {
        if(field.type === INPUT_TYPE.MULTI_SELECT) {
            const fieldOptions = options;
            value?.forEach((v) => {
                const valueFromOptions = fieldOptions[v];
                if(!Utility.isEmpty(valueFromOptions) && valueFromOptions?.id) {
                    data.push(valueFromOptions.id);
                }
            })
        } 
    }
    return data;
  }
}
